export const PUBLIC_PHONE: string = '88003017340';

export function formatPhoneNumber(phoneNumber: string, shouldReplaceEight = false): string {
    let result = phoneNumber;

    if (shouldReplaceEight && phoneNumber.startsWith('8')) {
        result = phoneNumber.replace(/\d/, '+7');
    }

    return result.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5');
}
export function formatPhone(phoneNumber: string): string {
    const input = getNormalizedPhone(phoneNumber);

    let formattedPhone = '+7 ';
    if (input.length > 0) {
        formattedPhone += '(' + input.substring(0, 3);
    }
    if (input.length >= 4) {
        formattedPhone += ') ' + input.substring(3, 6);
    }
    if (input.length >= 7) {
        formattedPhone += '-' + input.substring(6, 8);
    }
    if (input.length >= 9) {
        formattedPhone += '-' + input.substring(8, 10);
    }
    if (input.length >= 10) {
        formattedPhone += '';
    }

    return formattedPhone;
}

export function getNormalizedPhone(phone: string):string  {
    return phone.replace(/^[8,7]{1}/g, '').replace(/[^0-9]/g, '');
}